import { render, staticRenderFns } from "./SeriousExpertReview.vue?vue&type=template&id=96b6ce02&scoped=true"
import script from "./SeriousExpertReview.vue?vue&type=script&lang=js"
export * from "./SeriousExpertReview.vue?vue&type=script&lang=js"
import style0 from "./SeriousExpertReview.vue?vue&type=style&index=0&id=96b6ce02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b6ce02",
  null
  
)

export default component.exports